import React, {Component} from 'react';
import {getWallCouponsList, changeStatusWallCoupons, makeExpireWallCoupons, removeWallItem} from '../../modules/Api';
import ReactTable from 'react-table'
import {END_POINT} from '../../constants/config';
import {Switch} from 'antd';
import history from '../../modules/History';
import {notification} from 'antd';
import {ACL, getAuthUserInfo, userHasPermission} from '../../components/ACL';

class WallCoupons extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            per_page: 15,
            count: 0,
            last_page: 1,
            current_query: '',
            user_info: getAuthUserInfo()
        }
    }
    componentDidMount() {
        //this.fetchData();
    }
    fetchData = (query = '') => {
        this.setState({data:[]}, function() {
            getWallCouponsList(query, (res) => {
                this.setState({
                data    : res.data,
                count    : res.total,
                last_page: res.last_page,
                per_page: res.per_page
            })});
        });
    }
    onChange(state) {
        if(!state.per_page) {
            state.per_page = 15;
        }
        const id = state.filtered.find(f => f.id ==='id') ? state.filtered.find(f => f.id ==='id').value : '';
        const status = state.filtered.find(f => f.id ==='status') ? state.filtered.find(f => f.id ==='status').value : '';
        const brand_name = state.filtered.find(f => f.id ==='brand_name') ? state.filtered.find(f => f.id ==='brand_name').value : '';
        const expiration_date = state.filtered.find(f => f.id ==='expiration_date') ? state.filtered.find(f => f.id ==='expiration_date').value : '';
        const code = state.filtered.find(f => f.id ==='code') ? state.filtered.find(f => f.id ==='code').value : '';
        let query = `page=${state.page  + 1}&per_page=${state.per_page}&brand_name=${brand_name}&code=${code}&expiration_date=${expiration_date}&status=${status}`;
        if (id) {
            query = query + `&id=` + id;
        }
        this.setState(
            {current_query: query}
        )
        this.fetchData(query);
    }
    changeStatus(id, checked) {
        if(!this.canEdit()){
            notification.open({
                message: `دسترسی ویرایش ندارید!`,
            });
            return false;
        }
        changeStatusWallCoupons(id, {
            'status' : checked
        }, () => {})
    }

    canEdit(permission = 'wall_management|wall_edit'){
        return userHasPermission(this.state.user_info.roles, this.state.user_info.permissions, permission);
    }

    makeExpire(id, checked) {
        if(!this.canEdit()){
            notification.open({
                message: `دسترسی ویرایش ندارید!`,
            });
            return false;
        }
        makeExpireWallCoupons(id, {
            'expire' : checked
        }, () => {})
    }
    removeWall(id) {
        const warningMessage = `آیا از حذف کوپن اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        const that = this;
        if (window.confirm(warningMessage)) {
            removeWallItem(id, () => {
                notification.open({
                    message: `حذف شد!`,
                });

                that.fetchData(that.state.current_query)
            })
        }
    }
    render() {
        const self = this;
        const columns = [
            {
                Header: 'آیدی',
                filterable: true,
                accessor: 'id'
            },
            {
                Header: 'کد تخفیف',
                accessor: 'code',
                filterable: true,
                Cell: (row) => (<ACL component="div" has_permission="wall_management|wall_edit" denied={() => {return row.original.code ? row.original.code : 'کد تخفیف';}} ><span style={{cursor: 'pointer'}} onClick={() => {window.open(`/wall/edit/${row.original.id}`, "_blank")}} title={row.original.code}>
                    {row.original.code ? row.original.code : 'کد تخفیف'}
                </span></ACL>)
            },
            {
                Header: 'منقضی شده',
                accessor: 'expiration_date',
                filterable: true,
                Cell: function(row) {
                    if(!self.canEdit()){
                        return <span>{row.original.expiration_date !== null ? 'منقضی شده' : 'معتبر'}</span>
                    }
                    if(row.original.expiration_date !== null) {
                        return (
                            <div>
                                <Switch defaultChecked onChange={function(checked){
                                    self.makeExpire(row.original.id, checked);
                                }} />
                            </div>
                        )
                    }

                    return (
                        <div>
                            <Switch onChange={function(checked){
                                self.makeExpire(row.original.id, checked);
                            }} />
                        </div>
                    )
                },
                Filter: ({ filter, onChange }) =>
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{ width: "100%" }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="all">همه</option>
                      <option value="true">منقضی شده</option>
                      <option value="false">منقضی نشده</option>
                    </select>
            },
            {
                Header: 'فروشگاه',
                accessor: 'brand_name',
                filterable: true,
                Cell: (row) => (
                <div>
                    {
                        row.original.store_logo
                        &&
                        <img
                        style={{maxWidth: '50px'}}
                        src={`${row.original.store_logo.includes('http') ? row.original.store_logo : END_POINT + row.original.store_logo}`}
                        alt={row.original.brand_name}
                        />
                    }
                    <span title={row.original.brand_name}> {row.original.brand_name} </span>
                </div>
            )
            },
            {
                Header: 'متن',
                accessor: 'content',
                Cell: (row) => (<span title={row.original.content}> {row.original.content} </span>)
            },
            {
                Header: 'وضعیت',
                accessor: 'status',
                filterable: true,
                Cell: function(row) {
                    if(!self.canEdit()){
                        return <span>{row.original.status === 1 || row.original.status === '1' ? 'فعال' : 'غیر فعال'}</span>
                    }
                    if(row.original.status === 1 || row.original.status === '1') {
                        return (
                            <div>
                                <Switch defaultChecked onChange={function(checked){
                                    self.changeStatus(row.original.id, checked);
                                }} />
                            </div>
                        );
                    }

                    return (
                        <div>
                            <Switch onChange={function(checked){
                                self.changeStatus(row.original.id, checked);
                            }} />
                        </div>
                    );
                },
                Filter: ({ filter, onChange }) =>
                    <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "all"}
                    >
                    <option value="all">همه</option>
                    <option value="true">فعال</option>
                    <option value="false">غیر فعال</option>
                    </select>
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (<ACL component="span" has_permission="wall_management|wall_delete"><span onClick={() => {this.removeWall(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>)
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.data}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.per_page, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default WallCoupons;


// WEBPACK FOOTER //
// ./src/containers/Wall/index.js